import { render, staticRenderFns } from "./Associates.vue?vue&type=template&id=c531312c&scoped=true"
import script from "./Associates.vue?vue&type=script&lang=js"
export * from "./Associates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c531312c",
  null
  
)

export default component.exports